import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IntroDescription from '../components/IntroDescription';
import IntroTitle from '../components/IntroTitle';
import { SmallIntroContainer } from './styles';
const SmallIntroComponent = (props) => {
    return (_jsxs(SmallIntroContainer, { children: [_jsx(IntroTitle, Object.assign({}, props)), _jsx(IntroDescription, Object.assign({}, props, { withBorder: "right", style: { paddingLeft: 0 } }))] }));
};
export default SmallIntroComponent;
